/*
 * @Author: leyuanyuan（lyyleyuanyuan@163.com）
 * @Date: 2019-12-27 15:32:40
 * @LastEditors: your name
 * @LastEditTime: 2023-07-20 10:17:39
 * @FilePath: /HTML/src/utils/tools.js
 */

const Tools = {
  getEchartsOptionCommon(chartObj) {
    return {
      tooltip: {
        trigger: "axis",
        height: 280,
        backgroundColor: " rgba(204, 69, 69,0.8);",
        borderColor: "#DDDDDF", //边框颜色
        borderWidth: 1, //边框线宽度
        textStyle: {
          //文字样式
          fontFamily: "MicrosoftYaHei",
          fontSize: Tools.fontSize(12),
          color: "#FFFFFF"
        }
      },
      legend: {
        top: 0,
        right: Tools.fontSize(20),
        itemWidth: Tools.fontSize(24),
        itemHeight: Tools.fontSize(4),
        data: [
          {
            name: "今年",
            icon: "rect"
          },
          {
            name: "去年",
            icon: "rect"
          }
        ],
        textStyle: {
          color: "#3A3A3B",
          fontSize: Tools.fontSize(14),
          letterSpacing: 0,
          fontFamily: "MicrosoftYaHei"
        }
      },
      grid: [
        {
          // show: false,
          top: Tools.fontSize(30),
          right: Tools.fontSize(20),
          left: Tools.fontSize(18),
          bottom: 0,
          containLabel: true
        }
      ],

      xAxis: {
        show: true,
        type: "category",
        // boundaryGap: true,
        // splitLine: { show: false },
        data: chartObj.xData,
        axisLabel: {
          interval: 3,
          // rotate: 40,
          show: true,
          textStyle: {
            fontFamily: "MicrosoftYaHei",
            fontSize: Tools.fontSize(14),
            // color: "#3A3A3B",
            color: "#3A3A3B",
            letterSpacing: 0,
            textAlign: "center"
          }
        },
        axisLine: {
          lineStyle: {
            color: "rgba(0,0,0,0.1)"
          }
        },
        axisTick: {
          show: false
        }
      },
      dataZoom:[
        // 滑动条
        {
           xAxisIndex:0, //这里是从X轴得0刻度开始
           show:true,    //是否显示滑动条，不影响使用
           type:"slider", //这个是dataZoom组件是slider型dataZoom组件
           startValue:chartObj.xData.length - 30,  // 这里从头开始
           endValue:chartObj.xData.length -1    // 一次性展示30个
        }
      ],
      yAxis: [
        {
          // name: ["NTG", "DB","DCL","行业大盘"],
          show: true,
          type: "log",
          splitLine: {
            show: false,
            lineStyle: {
              type: "dashed"
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "white"
            }
          },
          axisLabel: {
            // interval: 0,
            show: true,
            textStyle: {
              fontFamily: "MicrosoftYaHei",
              fontSize: Tools.fontSize(14),
              // color: "#3A3A3B",
              color: "#3A3A3B",
              letterSpacing: 0,
              textAlign: "center"
            }
          },
          min: "dataMin", //取最小值为最小刻度
          // max: 'dataMax', //取最大值为最大刻度
          scale: true //自适应
          // minInterval: 1000000, //分割刻度
          // min: 0,
        }
      ],
      series: [
        {
          name: "今年",
          type: "line",
          data: chartObj["seriesData"][0].map(item => {
            return item == 0 ? null : item;
          }),
          symbol: "none",
          // symbol: "circle",
          // data:[120, 132, 101, 134, 90, 230, 210,120, 132, 101, 134, 90, 230, 210],
          // yAxisIndex: 0,
          // symbolSize: 6,
          itemStyle: {
            normal: {
              color: "#F6BD16" //折线颜色
            }
          }
        },
        {
          name: "去年",
          type: "line",
          data: chartObj["seriesData"][1].map(item => {
            return item == 0 ? null : item;
          }),
          symbol: "none",
          // symbol: "circle",
          // symbolSize: 6,
          // data:[220, 182, 191, 234, 290, 330, 310,220, 182, 191, 234, 290, 330, 310],
          // yAxisIndex: 0,
          itemStyle: {
            normal: {
              color: "#6A67A0"
            }
          }
        }
      ]
    };
  },
  // 图表echarts内根据rem获得px大小
  fontSize(font) {
    if (!font) return;
    let falg = String(font).includes("px");
    if (falg) {
      font = String(font).split("px")[0];
    }
    let numFont = 47 / font;
    let size = document.documentElement.style.fontSize.split("px")[0];
    console.log(size, "19-----");
    let fontSize = (size / numFont).toFixed();
    console.log(fontSize, "166-----");
    return falg ? fontSize + "px" : Number(fontSize);
  }
};

export default Tools;



// WEBPACK FOOTER //
// ./src/utils/tools.js